import PropTypes from 'prop-types'
import styles from './styles'

/** @jsx jsx */
import { css, jsx } from '@emotion/react'

const SmallTitleBase = ({
  children,
  colour,
  component: Component,
  componentStyles,
  isMobile
}) => {
  return (
    <Component
      css={css`
        ${styles(colour)}
        ${componentStyles.base}
        ${isMobile && componentStyles.mobile}
      `}
    >
      {children}
    </Component>
  )
}

SmallTitleBase.propTypes = {
  component: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']).isRequired
}

export default SmallTitleBase
